export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_evgExpenseNo') || 'EVG费用填报单编号',
    field: 'evgExpenseNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonName') || '业务人员',
    field: 'salesPersonName',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('form_label_evgExpenseStatus') || '状态',
    field: 'evgExpenseStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_oaExpenseProcess') || 'OA申请方式',
    field: 'v_oaExpenseProcess',
    minWidth: 160,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_payeeType') || '收款方',
    field: 'v_payeeType',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_payeeCustName') || '收款单位',
    field: 'payeeName',
    minWidth: 200,
    align: 'center',
  },
  {
    title: that.$l('form_label_currencyAmount') || '费用合计',
    field: 'currencyAmount',
    minWidth: 150,
    align: 'center',
    slots: { default: 'showAmount' },
  },
  {
    title: that.$l('table_label_expensePayerName') || '付款公司',
    field: 'expensePayerName',
    minWidth: 220,
    align: 'center',
  },
  {
    title: that.$l('form_label_paymentMethod') || '付款方式',
    field: 'v_paymentMethod',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    slots: { default: 'createByName' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    slots: { default: 'modifyByName' }
  }
]
